module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781459262027_i0001.jpg",
      "src": "e9781459262027_i0001.jpg"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Three houses, three")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("couples—three reasons")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("for revenge")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The calm ambience of St. Fiacre’s Hill—where lavish homes provided a secure haven for the seriously rich—hid a mael-strom of feeling. Geraint Howell-Williams, Triss Alexander and Dominic Dashwood all thought they had a need to avenge—but the actions each set in motion gained a steam-roller life of their own, with entirely unexpected results.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GETTING EVEN is the first book in Sharon Kendrick’s REVENGE IS SWEET trilogy. Look out for Triss’s story coming next month in KISS AND TELL (#1951), and Dominic’s story, SETTLING THE SCORE (#1957), is out in May.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5c14542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781459262027_fm01.vue
// module id = 60
// module chunks = 0